export const imageWidths = [240, 320, 480, 960, 1920];
export const teaserImageWidth = 480;
export const posterImageWidth = 240;
export const gridTeaserImageWidth = 480;
export const smallGridTeaserImageWidth = 240;
export const xLargeGridTeaserImageWidth = 480;
export const teaserElementImageWidth = 960;
export const highlightImageWidth = 1920;
export const largeHighlightImageWidth = 960;